// extracted by mini-css-extract-plugin
module.exports = {"blockNotifications":"test-notification-page_blockNotifications__SUjVM","list":"test-notification-page_list__MCJMi"};